<template>
  <div>
    <CustomError v-if="is_error" />
    <Loading v-if="is_loading" />
    <div v-if="!is_loading">
      <h2>Login</h2>
      <form @submit.prevent="submit">
        <div class="signedup" v-if="signedup">
          You have signed up successfully. <br />Please log in.
        </div>
        <div class="form-group">
          <input
            class="form-control"
            type="text"
            v-model="email"
            name="email"
            placeholder="Email"
          />
        </div>
        <div class="form-group">
          <input
            class="form-control"
            type="password"
            v-model="password"
            name="password"
            placeholder="Password"
          />
        </div>
        <div class="form-group error" v-if="message">{{ message }}</div>
        <div class="form-group">
          <button class="btn btn-primary">Login</button>
          <!-- <router-link to="/signup" class="btn btn-link">Sign up</router-link> -->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Loading from '@/components/Loading'
import CustomError from '@/components/CustomError'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'SignUp',
  components: {
    Loading,
    CustomError
  },
  data() {
    return {
      nick: '',
      email: '',
      password: '',
      signedup: false,
      message: ''
    }
  },
  created() {
    this.$store.dispatch('user/logout')
    if (this.$route.query.signedup) {
      this.signedup = true
    }
  },
  computed: {
    is_loading() {
      return this.isLoading()
    },
    is_error() {
      return this.isError()
    }
  },
  methods: {
    ...mapGetters('user', ['isLoading', 'isError']),
    ...mapActions('user', ['login']),
    async submit() {
      try {
        const user = { email: this.email, password: this.password }
        const result = await this.login(user)
        if (result === true) {
          this.message = ''
          this.$router.push({ path: '/fields' })
        } else {
          this.message = 'Login error!'
        }
      } catch (err) {
        this.message = err.response.data.error
      }
    }
  }
}
</script>
